import Email from './Email.vue';
export default Email;



// WEBPACK FOOTER //
// ./src/pages/verify/email/index.js